import { useEffect } from "react";

/**
 * "Don't reload the page under me" holds (2026-10-23).
 *
 * `useVersionCheck` used to reload 8s after spotting a new build whenever the tab came
 * back from ≥60s in the background — which is exactly when a member returns from their
 * mail app with a reset / verification code. The reload wiped /forgot's step, the
 * composer's authwall, and on /email-verify fired a fresh code. Anything mid-flow takes a
 * hold while it is on screen (every open `Dialog`, the forgot form, the verify page) and
 * the version check only auto-reloads with zero holds on a safe route. Module-level
 * counter rather than context: the checker lives in __root, the holders anywhere below.
 */
let holds = 0;

export function hasReloadHold(): boolean {
  return holds > 0;
}

/** Hold off automatic reloads while `active` (default true) and mounted. */
export function useReloadHold(active = true): void {
  useEffect(() => {
    if (!active) return;
    holds += 1;
    return () => {
      holds -= 1;
    };
  }, [active]);
}
